import http from 'utils/http';
import { MY_TEAM_URL } from 'constants/endpoints';
import type { ServiceParams } from 'interface/service';

export async function fetchMyTeam(params: ServiceParams) {
  const { data } = await http.get(MY_TEAM_URL, { params });

  return data;
}
